module.exports = __webpack_public_path__ + "img/ai_histories.8982733e.png";